import { render, staticRenderFns } from "./requestdetails.vue?vue&type=template&id=310212c2&"
import script from "./requestdetails.vue?vue&type=script&lang=ts&"
export * from "./requestdetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports